import { getElectronBridge } from "@/utils/electronBridge";

export type ExxConnectAnimationSource = {
  url: string;
};

let cachedSource: ExxConnectAnimationSource | null = null;
const listeners = new Set<(source: ExxConnectAnimationSource) => void>();

function prefetchConnectAnimation(url: string) {
  if (!url) return;
  const video = document.createElement("video");
  video.preload = "auto";
  video.muted = true;
  video.playsInline = true;
  video.src = url;
}

function applyExxConnectAnimationSource(source: ExxConnectAnimationSource) {
  cachedSource = source;
  prefetchConnectAnimation(source.url);
  listeners.forEach((listener) => {
    try {
      listener(source);
    } catch {
      /* ignore */
    }
  });
}

export function getExxConnectAnimationSource(): ExxConnectAnimationSource | null {
  return cachedSource;
}

/** @deprecated 使用 getExxConnectAnimationSource */
export function getExxConnectAnimationUrls(): ExxConnectAnimationSource | null {
  return getExxConnectAnimationSource();
}

export function subscribeExxConnectAnimationSource(
  listener: (source: ExxConnectAnimationSource) => void
): () => void {
  listeners.add(listener);
  if (cachedSource) {
    listener(cachedSource);
  }
  return () => {
    listeners.delete(listener);
  };
}

/** @deprecated 使用 subscribeExxConnectAnimationSource */
export function subscribeExxConnectAnimationUrls(
  listener: (source: ExxConnectAnimationSource) => void
): () => void {
  return subscribeExxConnectAnimationSource(listener);
}

export function installExxConnectAnimationListener(): (() => void) | undefined {
  const bridge = getElectronBridge();
  if (!bridge?.onElectronMessage) return undefined;

  return bridge.onElectronMessage((type, data) => {
    if (type !== "exx-connect-animation-url") return;
    const payload = data as Partial<ExxConnectAnimationSource> | null;
    if (!payload || typeof payload.url !== "string" || !payload.url.trim()) {
      return;
    }
    applyExxConnectAnimationSource({ url: payload.url.trim() });
  });
}
